import { ImageGenerationType } from '@/.gql/graphql';

// Типы для элементов, которые могут содержать промо
export interface PromoItem {
  __typename?:
    | 'Style'
    | 'PhotoSession'
    | 'Effect'
    | 'CombiVideo'
    | 'StoryLine'
    | 'VideoLook'
    | 'VideoStyle'
    | 'VideoVeo3';
  id: string;
}

/**
 * Возвращает тип генерации на основе __typename элемента
 * @param item - элемент с __typename
 * @returns ImageGenerationType или null для неподдерживаемых типов
 */
export const getGenerationType = (item: PromoItem | null | undefined): ImageGenerationType | null => {
  switch (item?.__typename) {
    case 'Style':
      return ImageGenerationType.Preset;
    case 'PhotoSession':
      return ImageGenerationType.PhotoSession;
    case 'Effect':
      return ImageGenerationType.EffectMode;
    // Другие типы не участвуют в акции
    default:
      return null;
  }
};